import { render, staticRenderFns } from "./DocumentAttachments.vue?vue&type=template&id=ca8c926a&"
import script from "./DocumentAttachments.vue?vue&type=script&lang=js&"
export * from "./DocumentAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports